import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CreateSignatureDialogContractStateService {
  private CreateSignatureDialogContractStateService = new Subject<any>();

  constructor() { }

  triggerDialogStatus(data: any) {
    this.CreateSignatureDialogContractStateService.next(data);
  }

  handleDialogStatus(): Observable<any> {
    return this.CreateSignatureDialogContractStateService.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/signature/signature.modal.state.service.ts